import { withInstall } from '@zoryn/utils'
import Row from './src/row.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZRow: SFCWithInstall<typeof Row> = withInstall(Row)
export default ZRow

export * from './src/row'
export * from './src/constants'
